/**
 * ── The recruiter's own Slack connection ─────────────────────────────────────
 *
 * What makes a feedback nudge arrive from them rather than from the TA bot. One grant per
 * recruiter, consented on Slack's own page.
 *
 * There is no token here on purpose: unlike the Gmail connection, the browser never handles this
 * credential — it posts as the person, and only the proxy's own send ever needs it.
 */
import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-people-520260363689.europe-west3.run.app';
const BASE = `${PROXY_URL}/api/ta-action-board/slack`;

export interface SlackConnection {
  /** Is the flow wired up on this proxy at all? False ⇒ every nudge comes from the bot. */
  configured: boolean;
  connected: boolean;
  grant?: { slackUserId: string | null; connectedAt: number | null; lastError: string | null } | null;
}

export async function fetchSlackConnection(): Promise<SlackConnection> {
  const res = await authenticatedFetch(`${BASE}/status`);
  return res.json();
}

/**
 * Start consent. Returns Slack's authorize URL — the caller navigates the whole page there, the
 * same full-page redirect the Gmail grant uses, because a popup is blocked as often as not.
 */
export async function startSlackConnect(returnTo: string): Promise<{ authorizeUrl: string }> {
  const res = await authenticatedFetch(`${BASE}/connect`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ returnTo }),
  });
  return res.json();
}

export async function disconnectSlack(): Promise<{ ok: boolean }> {
  const res = await authenticatedFetch(`${BASE}/disconnect`, { method: 'POST' });
  return res.json();
}
